import React, { Suspense } from 'react';
import { pagesConfig } from './pages.config'
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { createPageUrl } from './utils';
const PageNotFound = React.lazy(() => import('./lib/PageNotFound'));
const CommercialPlumberBrisbane = React.lazy(() => import('./pages/CommercialPlumberBrisbane'));
const CommercialPlumberNorthLakes = React.lazy(() => import('./pages/CommercialPlumberNorthLakes'));
const CommercialPlumberIpswich = React.lazy(() => import('./pages/CommercialPlumberIpswich'));
const CommercialPlumberChermside = React.lazy(() => import('./pages/CommercialPlumberChermside'));
const CommercialPlumberFortitudeValley = React.lazy(() => import('./pages/CommercialPlumberFortitudeValley'));
const CommercialPlumberNewstead = React.lazy(() => import('./pages/CommercialPlumberNewstead'));
const CommercialPlumberSouthBrisbane = React.lazy(() => import('./pages/CommercialPlumberSouthBrisbane'));
const CommercialPlumberCaboolture = React.lazy(() => import('./pages/CommercialPlumberCaboolture'));
const CommercialPlumberLogan = React.lazy(() => import('./pages/CommercialPlumberLogan'));
const CommercialPlumberRedcliffe = React.lazy(() => import('./pages/CommercialPlumberRedcliffe'));
const CommercialPlumberBrendale = React.lazy(() => import('./pages/CommercialPlumberBrendale'));
const CommercialPlumberSpringfield = React.lazy(() => import('./pages/CommercialPlumberSpringfield'));
const CommercialPlumberMoretonBay = React.lazy(() => import('./pages/CommercialPlumberMoretonBay'));
const CommercialPlumberSunshineCoast = React.lazy(() => import('./pages/CommercialPlumberSunshineCoast'));
const CommercialPlumberGoldCoast = React.lazy(() => import('./pages/CommercialPlumberGoldCoast'));
const CommercialPlumberToowoomba = React.lazy(() => import('./pages/CommercialPlumberToowoomba'));
const ServiceAreas = React.lazy(() => import('./pages/ServiceAreas'));
const CommercialPlumberMountSamson = React.lazy(() => import('./pages/CommercialPlumberMountSamson'));
const CommercialPlumberBrownsPlains = React.lazy(() => import('./pages/CommercialPlumberBrownsPlains'));
const CommercialPlumberInala = React.lazy(() => import('./pages/CommercialPlumberInala'));
const CommercialPlumberCoomera = React.lazy(() => import('./pages/CommercialPlumberCoomera'));
const CommercialPlumberCleveland = React.lazy(() => import('./pages/CommercialPlumberCleveland'));
const CommercialPlumberRedlandBay = React.lazy(() => import('./pages/CommercialPlumberRedlandBay'));
const CommercialPlumberCapalaba = React.lazy(() => import('./pages/CommercialPlumberCapalaba'));
const CommercialPlumberOrmeau = React.lazy(() => import('./pages/CommercialPlumberOrmeau'));
const CommercialPlumberYatala = React.lazy(() => import('./pages/CommercialPlumberYatala'));
const CommercialPlumberHelensvale = React.lazy(() => import('./pages/CommercialPlumberHelensvale'));
const CommercialPlumberRobina = React.lazy(() => import('./pages/CommercialPlumberRobina'));
const CommercialPlumberBurleighWaters = React.lazy(() => import('./pages/CommercialPlumberBurleighWaters'));
const CommercialPlumberNerang = React.lazy(() => import('./pages/CommercialPlumberNerang'));
const CommercialPlumberRipley = React.lazy(() => import('./pages/CommercialPlumberRipley'));
const CommercialPlumberRedbankPlains = React.lazy(() => import('./pages/CommercialPlumberRedbankPlains'));
const CommercialPlumberForestLake = React.lazy(() => import('./pages/CommercialPlumberForestLake'));
const CommercialPlumberJindalee = React.lazy(() => import('./pages/CommercialPlumberJindalee'));
const CommercialPlumberSouthport = React.lazy(() => import('./pages/CommercialPlumberSouthport'));
const CommercialPlumberBurleighHeads = React.lazy(() => import('./pages/CommercialPlumberBurleighHeads'));
const CommercialPlumberBroadbeach = React.lazy(() => import('./pages/CommercialPlumberBroadbeach'));
const CommercialPlumberVarsityLakes = React.lazy(() => import('./pages/CommercialPlumberVarsityLakes'));
const CommercialPlumberHopeIsland = React.lazy(() => import('./pages/CommercialPlumberHopeIsland'));
const CommercialPlumberPimpama = React.lazy(() => import('./pages/CommercialPlumberPimpama'));
const CommercialPlumberUpperCoomera = React.lazy(() => import('./pages/CommercialPlumberUpperCoomera'));
const CommercialPlumberBiggeraWaters = React.lazy(() => import('./pages/CommercialPlumberBiggeraWaters'));
const CommercialPlumberRocklea = React.lazy(() => import('./pages/CommercialPlumberRocklea'));
const CommercialPlumberEagleFarm = React.lazy(() => import('./pages/CommercialPlumberEagleFarm'));
const CommercialPlumberMurarrie = React.lazy(() => import('./pages/CommercialPlumberMurarrie'));
const CommercialPlumberBeenleigh = React.lazy(() => import('./pages/CommercialPlumberBeenleigh'));
const CommercialPlumberLoganCentral = React.lazy(() => import('./pages/CommercialPlumberLoganCentral'));
const CommercialPlumberShailerPark = React.lazy(() => import('./pages/CommercialPlumberShailerPark'));
const CommercialPlumberLoganholme = React.lazy(() => import('./pages/CommercialPlumberLoganholme'));
const Industries = React.lazy(() => import('./pages/Industries'));
const IndustryCafes = React.lazy(() => import('./pages/IndustryCafes'));
const IndustryRestaurants = React.lazy(() => import('./pages/IndustryRestaurants'));
const IndustryRetail = React.lazy(() => import('./pages/IndustryRetail'));
const IndustryBeautyNailSalons = React.lazy(() => import('./pages/IndustryBeautyNailSalons'));
const IndustryMedicalCentres = React.lazy(() => import('./pages/IndustryMedicalCentres'));
const IndustryOffices = React.lazy(() => import('./pages/IndustryOffices'));
const IndustryCommercialKitchens = React.lazy(() => import('./pages/IndustryCommercialKitchens'));
const IndustryShoppingCentreTenancies = React.lazy(() => import('./pages/IndustryShoppingCentreTenancies'));
const GreasePitPlumbingBrisbane = React.lazy(() => import('./pages/GreasePitPlumbingBrisbane'));
const GreasePitPlumbingGoldCoast = React.lazy(() => import('./pages/GreasePitPlumbingGoldCoast'));
const GreasePitPlumbingToowoomba = React.lazy(() => import('./pages/GreasePitPlumbingToowoomba'));
const GreasePitPlumbingSouthBrisbane = React.lazy(() => import('./pages/GreasePitPlumbingSouthBrisbane'));
const GreasePitPlumbingSunshineCoast = React.lazy(() => import('./pages/GreasePitPlumbingSunshineCoast'));
const GreasePitPlumbingMoretonBay = React.lazy(() => import('./pages/GreasePitPlumbingMoretonBay'));
const GreasePitPlumbingLogan = React.lazy(() => import('./pages/GreasePitPlumbingLogan'));
const GreasePitPlumbingIpswich = React.lazy(() => import('./pages/GreasePitPlumbingIpswich'));
const CommercialBathroomPlumbingBrisbane = React.lazy(() => import('./pages/CommercialBathroomPlumbingBrisbane'));
const CommercialBathroomPlumbingGoldCoast = React.lazy(() => import('./pages/CommercialBathroomPlumbingGoldCoast'));
const CommercialBathroomPlumbingSouthBrisbane = React.lazy(() => import('./pages/CommercialBathroomPlumbingSouthBrisbane'));
const CommercialCarWashPlumbingBrisbane = React.lazy(() => import('./pages/CommercialCarWashPlumbingBrisbane'));
const CommercialCarWashPlumbingGoldCoast = React.lazy(() => import('./pages/CommercialCarWashPlumbingGoldCoast'));
const CommercialCarWashPlumbingToowoomba = React.lazy(() => import('./pages/CommercialCarWashPlumbingToowoomba'));
const CommercialCarWashPlumbingSouthBrisbane = React.lazy(() => import('./pages/CommercialCarWashPlumbingSouthBrisbane'));
const CommercialCarWashPlumbingSunshineCoast = React.lazy(() => import('./pages/CommercialCarWashPlumbingSunshineCoast'));
const CommercialCarWashPlumbingMoretonBay = React.lazy(() => import('./pages/CommercialCarWashPlumbingMoretonBay'));
const CommercialCarWashPlumbingLogan = React.lazy(() => import('./pages/CommercialCarWashPlumbingLogan'));
const CommercialCarWashPlumbingIpswich = React.lazy(() => import('./pages/CommercialCarWashPlumbingIpswich'));
const ProjectDetailPage = React.lazy(() => import('./pages/ProjectDetailPage'));
import FloatingQuoteCTALarge from './components/plumbing/FloatingQuoteCTALarge';
import SiteStructuredData from './components/plumbing/SiteStructuredData';

const { Pages, Layout, mainPage } = pagesConfig;
const mainPageKey = mainPage ?? Object.keys(Pages)[0];
const MainPage = mainPageKey ? Pages[mainPageKey] : <></>;

const LayoutWrapper = ({ children, currentPageName }) => Layout ?
  <Layout currentPageName={currentPageName}>{children}</Layout>
  : <>{children}</>;

const AuthenticatedApp = () => {
  return (
    <Suspense fallback={<div className="fixed inset-0 flex items-center justify-center bg-[#050505]"><div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin" /></div>}>
      <Routes>
      <Route path="/" element={
        <LayoutWrapper currentPageName={mainPageKey}>
          <MainPage />
        </LayoutWrapper>
      } />
      {Object.entries(Pages).filter(([path]) => path !== 'Home').map(([path, Page]) => (
        <Route
          key={path}
          path={createPageUrl(path)}
          caseSensitive
          element={
            <LayoutWrapper currentPageName={path}>
              <Page />
            </LayoutWrapper>
          }
        />
      ))}
      {Object.keys(Pages).filter(path => `/${path}` !== createPageUrl(path)).map(path => (
        <Route key={`legacy-${path}`} path={`/${path}`} caseSensitive element={<CanonicalRedirect to={createPageUrl(path)} />} />
      ))}
      <Route path="/commercial-plumber-brisbane" element={<CommercialPlumberBrisbane />} />
      <Route path="/commercial-plumber-north-lakes" element={<CommercialPlumberNorthLakes />} />
      <Route path="/commercial-plumber-ipswich" element={<CommercialPlumberIpswich />} />
      <Route path="/commercial-plumber-chermside" element={<CommercialPlumberChermside />} />
      <Route path="/commercial-plumber-fortitude-valley" element={<CommercialPlumberFortitudeValley />} />
      <Route path="/commercial-plumber-newstead" element={<CommercialPlumberNewstead />} />
      <Route path="/commercial-plumber-south-brisbane" element={<CommercialPlumberSouthBrisbane />} />
      <Route path="/commercial-plumber-caboolture" element={<CommercialPlumberCaboolture />} />
      <Route path="/commercial-plumber-logan" element={<CommercialPlumberLogan />} />
      <Route path="/commercial-plumber-redcliffe" element={<CommercialPlumberRedcliffe />} />
      <Route path="/commercial-plumber-brendale" element={<CommercialPlumberBrendale />} />
      <Route path="/commercial-plumber-springfield" element={<CommercialPlumberSpringfield />} />
      <Route path="/commercial-plumber-moreton-bay" element={<CommercialPlumberMoretonBay />} />
      <Route path="/commercial-plumber-sunshine-coast" element={<CommercialPlumberSunshineCoast />} />
      <Route path="/commercial-plumber-gold-coast" element={<CommercialPlumberGoldCoast />} />
      <Route path="/commercial-plumber-toowoomba" element={<CommercialPlumberToowoomba />} />
      <Route path="/service-areas" element={<ServiceAreas />} />
      <Route path="/commercial-plumber-mount-samson" element={<CommercialPlumberMountSamson />} />
      <Route path="/commercial-plumber-browns-plains" element={<CommercialPlumberBrownsPlains />} />
      <Route path="/commercial-plumber-inala" element={<CommercialPlumberInala />} />
      <Route path="/commercial-plumber-coomera" element={<CommercialPlumberCoomera />} />
      <Route path="/commercial-plumber-cleveland" element={<CommercialPlumberCleveland />} />
      <Route path="/commercial-plumber-redland-bay" element={<CommercialPlumberRedlandBay />} />
      <Route path="/commercial-plumber-capalaba" element={<CommercialPlumberCapalaba />} />
      <Route path="/commercial-plumber-ormeau" element={<CommercialPlumberOrmeau />} />
      <Route path="/commercial-plumber-yatala" element={<CommercialPlumberYatala />} />
      <Route path="/commercial-plumber-helensvale" element={<CommercialPlumberHelensvale />} />
      <Route path="/commercial-plumber-robina" element={<CommercialPlumberRobina />} />
      <Route path="/commercial-plumber-burleigh-waters" element={<CommercialPlumberBurleighWaters />} />
      <Route path="/commercial-plumber-nerang" element={<CommercialPlumberNerang />} />
      <Route path="/commercial-plumber-ripley" element={<CommercialPlumberRipley />} />
      <Route path="/commercial-plumber-redbank-plains" element={<CommercialPlumberRedbankPlains />} />
      <Route path="/commercial-plumber-forest-lake" element={<CommercialPlumberForestLake />} />
      <Route path="/commercial-plumber-jindalee" element={<CommercialPlumberJindalee />} />
      <Route path="/commercial-plumber-southport" element={<CommercialPlumberSouthport />} />
      <Route path="/commercial-plumber-burleigh-heads" element={<CommercialPlumberBurleighHeads />} />
      <Route path="/commercial-plumber-broadbeach" element={<CommercialPlumberBroadbeach />} />
      <Route path="/commercial-plumber-varsity-lakes" element={<CommercialPlumberVarsityLakes />} />
      <Route path="/commercial-plumber-hope-island" element={<CommercialPlumberHopeIsland />} />
      <Route path="/commercial-plumber-pimpama" element={<CommercialPlumberPimpama />} />
      <Route path="/commercial-plumber-upper-coomera" element={<CommercialPlumberUpperCoomera />} />
      <Route path="/commercial-plumber-biggera-waters" element={<CommercialPlumberBiggeraWaters />} />
      <Route path="/commercial-plumber-rocklea" element={<CommercialPlumberRocklea />} />
      <Route path="/commercial-plumber-eagle-farm" element={<CommercialPlumberEagleFarm />} />
      <Route path="/commercial-plumber-murarrie" element={<CommercialPlumberMurarrie />} />
      <Route path="/commercial-plumber-beenleigh" element={<CommercialPlumberBeenleigh />} />
      <Route path="/commercial-plumber-logan-central" element={<CommercialPlumberLoganCentral />} />
      <Route path="/commercial-plumber-shailer-park" element={<CommercialPlumberShailerPark />} />
      <Route path="/commercial-plumber-loganholme" element={<CommercialPlumberLoganholme />} />
      <Route path="/industries" element={<Industries />} />
      <Route path="/industries/cafes" element={<IndustryCafes />} />
      <Route path="/industries/restaurants" element={<IndustryRestaurants />} />
      <Route path="/industries/retail" element={<IndustryRetail />} />
      <Route path="/industries/beauty-nail-salons" element={<IndustryBeautyNailSalons />} />
      <Route path="/industries/medical-centres" element={<IndustryMedicalCentres />} />
      <Route path="/industries/offices" element={<IndustryOffices />} />
      <Route path="/industries/commercial-kitchens" element={<IndustryCommercialKitchens />} />
      <Route path="/industries/shopping-centre-tenancies" element={<IndustryShoppingCentreTenancies />} />
      <Route path="/grease-pit-plumbing-brisbane" element={<GreasePitPlumbingBrisbane />} />
      <Route path="/grease-pit-plumbing-gold-coast" element={<GreasePitPlumbingGoldCoast />} />
      <Route path="/grease-pit-plumbing-toowoomba" element={<GreasePitPlumbingToowoomba />} />
      <Route path="/grease-pit-plumbing-south-brisbane" element={<GreasePitPlumbingSouthBrisbane />} />
      <Route path="/grease-pit-plumbing-sunshine-coast" element={<GreasePitPlumbingSunshineCoast />} />
      <Route path="/grease-pit-plumbing-moreton-bay" element={<GreasePitPlumbingMoretonBay />} />
      <Route path="/grease-pit-plumbing-logan" element={<GreasePitPlumbingLogan />} />
      <Route path="/grease-pit-plumbing-ipswich" element={<GreasePitPlumbingIpswich />} />
      <Route path="/commercial-bathroom-plumbing-brisbane" element={<CommercialBathroomPlumbingBrisbane />} />
      <Route path="/commercial-bathroom-plumbing-gold-coast" element={<CommercialBathroomPlumbingGoldCoast />} />
      <Route path="/commercial-bathroom-plumbing-south-brisbane" element={<CommercialBathroomPlumbingSouthBrisbane />} />
      <Route path="/commercial-car-wash-plumbing-brisbane" element={<CommercialCarWashPlumbingBrisbane />} />
      <Route path="/commercial-car-wash-plumbing-gold-coast" element={<CommercialCarWashPlumbingGoldCoast />} />
      <Route path="/commercial-car-wash-plumbing-toowoomba" element={<CommercialCarWashPlumbingToowoomba />} />
      <Route path="/commercial-car-wash-plumbing-south-brisbane" element={<CommercialCarWashPlumbingSouthBrisbane />} />
      <Route path="/commercial-car-wash-plumbing-sunshine-coast" element={<CommercialCarWashPlumbingSunshineCoast />} />
      <Route path="/commercial-car-wash-plumbing-moreton-bay" element={<CommercialCarWashPlumbingMoretonBay />} />
      <Route path="/commercial-car-wash-plumbing-logan" element={<CommercialCarWashPlumbingLogan />} />
      <Route path="/commercial-car-wash-plumbing-ipswich" element={<CommercialCarWashPlumbingIpswich />} />
      <Route path="/projects/:slug" element={<ProjectDetailPage />} />
      <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};


function CanonicalRedirect({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={to + search + hash} replace />;
}

export function SiteContent() {
  return (
    <>
      <SiteStructuredData />
      <AuthenticatedApp />
      <FloatingQuoteCTALarge />
    </>
  )
}

function App() {
  return <Router><SiteContent /></Router>;
}

export default App
